import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedBody from '../../Common/FixedBody';
import ScrollToTopOnMount from '../../Common/ScrollToTopOnMount';
import BaseFilter from '../Base';
import { Popup } from '../../Popup';
import { MultiSelect, RadioGroup } from '../../Controls';
import { VIEW_MODE } from '../../../consts';

class ExtendSearchBase extends BaseFilter {
  /**
   * Возвращает значение из фильтра
   * @param field
   * @param defaultValue
   * @returns {*}
   */
  getFilter (field, defaultValue = null) {
    return this.props.filter.get(field, defaultValue) || defaultValue;
  }

  /**
   * Обновляет фильтр
   * @param field ключ или объект ключ:значение
   * @param value
   */
  setFilter (field, value) {
    const hasValue = arguments.length === 2;

    if (hasValue) {
      this.props.onUpdate({
        [field]: value
      });
    } else {
      this.props.onUpdate(field);
    }
  }

  hasMls () {
    const userExist = this.getUserId() > 0;
    const hasMls = this.props.user.getIn(['data', 'hasMls'], false) || false;

    return userExist && hasMls;
  }

  handlerMls (id, select) {
    const filter = {
      isMls: (select ? 1 : null)
    };

    if (select) {
      filter.onlyOwners = null;
    } else {
      filter.withoutComplaint = null;
    }
    this.setFilter(filter);
  }

  getHandlerFloat (field, maxLength = 10) {
    return (e) => {
      const value = e.target.value;
      if (value.length > maxLength) {
        return;
      }

      let number = value.replace(',', '.');
      if (!number.match(/^\d+\.$/)) {
        number = isNaN(parseFloat(number)) ? null : parseFloat(number);
      }

      this.setFilter(field, number);
    };
  }

  getHandlerInt (field, maxLength = 10) {
    return (e) => {
      const value = e.target.value;
      if (value.length > maxLength) {
        return;
      }

      const number = isNaN(parseInt(value)) ? null : parseInt(value);
      this.setFilter(field, number);
    };
  }

  getHandlerString (field, maxLength = 100) {
    return (e) => {
      const value = e.target.value.replace(/\s{2,}/, ' ');
      if (value.length > maxLength) {
        return;
      }

      this.setFilter(field, value);
    };
  }

  renderPanel () {
    return <h2>not yet implemented</h2>;
  }

  renderControlGroup (label, children) {
    return (
      <div className='control-group'>
        <div className='control-label'>{label}</div>
        <div className='controls'>
          {children}
        </div>
      </div>
    );
  }

  renderMultiSelect (label, name, items, scrolling = false, placeholder = 'Неважно', searchable = false) {
    return this.renderControlGroup(label, (
      <MultiSelect
        items={items}
        name={name}
        value={this.getFilter(name)}
        placeholder={placeholder}
        scrolling={scrolling}
        onUpdate={(_, id) => this.setFilter(name, id)}
        searchable={searchable}
      />
    ));
  }

  renderRadioGroup (label, name, items) {
    return this.renderControlGroup(label, (
      <RadioGroup
        items={items}
        name={name}
        value={this.getFilter(name)}
        onUpdate={(field, value) => this.setFilter(field, value)}
      />
    ));
  }

  renderGroupPills (searchParam, styleClassName, groupLabel, firstPropLabel, secondPropLabel) {
    const isPreference = this.getFilter(searchParam);
    const anyClass = classNames('btn btn-base', { pressed: !isPreference });
    const firstClass = classNames('btn btn-base', { pressed: isPreference === '1' });
    const secondClass = classNames('btn btn-base', { pressed: isPreference === '2' });

    const handler = (key) => {
      return () => {
        const state = {
          [searchParam]: key !== '' ? key : null,
        };

        this.setFilter(state);
      };
    };

    return this.renderControlGroup(groupLabel, (
      <div className={'btn-group-pills ' + (styleClassName ? styleClassName : '')} role='group'>
        <button type='button' onClick={handler()} className={anyClass}>Неважно</button>
        <button type='button' onClick={handler('1')} className={firstClass}>{firstPropLabel}</button>
        <button type='button' onClick={handler('2')} className={secondClass}>{secondPropLabel}</button>
      </div>
    ));
  }

  /**
   * Отображает: лэйбл + список инпутов + префикс
   * items = [ {name: '', placeholder: '', handler: func}, ... ]
   * @param label
   * @param suffix
   * @param items
   * @returns {JSX}
   */
  renderInputGroup (label, suffix, items) {
    return (
      <div className='control-group'>
        <div className='control-label'>{label}</div>
        <div className='controls'>
          {
            items.map(item => {
              return (
                <div key={item.name} className={'input-item input-item-' + item.name}>
                  <input
                    className='text-base'
                    type='text'
                    placeholder={item.placeholder}
                    value={this.getFilter(item.name) || ''}
                    onChange={item.handler} />
                </div>
              );
            })
          }
          {suffix}
        </div>
      </div>
    );
  }

  renderMapSubmit () {
    return this.getValue('viewMode') !== VIEW_MODE.map && (
      <button onClick={this.props.onSubmitMap} className='btn-base btn-hollow primary submit'>
        <span className="icon icon-map-marker-new"></span>
        На карте
      </button>
    );
  }

  render () {
    const { onReset, onSubmit, offerCount } = this.props;

    return (
      <Popup
        opened
        direction='bottom-left'
        className='extend-filter-popup'
        mainOffset={0}
        secondaryOffset={0}
      >
        <FixedBody />
        <ScrollToTopOnMount />

        <div className='extend-filter-control-modal'
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <div className='extend-filter__wrp'>
            <div className='extend-filter__filter-panel'>
              { this.renderPanel() }
            </div>
          </div>
          <div className='extend-filter__control-panel'>
            <div className='control-panel__container'>
              <button className='btn-base btn-reset' type='reset' onClick={onReset}>
                Очистить фильтр
              </button>
            </div>
            <div className='control-panel__container'>
              { this.renderMapSubmit() }
              <button className='btn-base btn-primary' type='submit' onClick={onSubmit}>
                {offerCount ? `Показать ${offerCount} объявлений` : 'Найти'}
              </button>
            </div>
          </div>
        </div>

      </Popup>
    );
  }
}

ExtendSearchBase.propTypes = {
  user: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,
  offerCount: PropTypes.number.isRequired,

  onUpdate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,

  onSubmitMap: PropTypes.func.isRequired
};

ExtendSearchBase.defaultProps = {};

export default ExtendSearchBase;



// WEBPACK FOOTER //
// ./src/ui/Search/ExtendSearch/ExtendSearchBase.jsx